import { useSyncExternalStore } from 'react';
import { getThemeVariant, THEME_VARIANTS } from 'core/components/theme/theme-variant';
import {
  getMotionPreference,
  getEnhancedLoadingPreference,
  MOTION_CHANGE_EVENT,
  REDUCED_MOTION_QUERY
} from 'core/components/theme/motion';

const reducedMotion = () => Boolean(window.matchMedia?.(REDUCED_MOTION_QUERY).matches);
const optedIn = () => getThemeVariant() === THEME_VARIANTS.RESKIN && getMotionPreference();
const loadingOptedIn = () => getThemeVariant() === THEME_VARIANTS.RESKIN && getEnhancedLoadingPreference();
const subscribe = (notify) => {
  const media = window.matchMedia?.(REDUCED_MOTION_QUERY);
  window.addEventListener('storage', notify);
  window.addEventListener(MOTION_CHANGE_EVENT, notify);
  media?.addEventListener('change', notify);
  return () => {
    window.removeEventListener('storage', notify);
    window.removeEventListener(MOTION_CHANGE_EVENT, notify);
    media?.removeEventListener('change', notify);
  };
};

export default function useMotionPreference() {
  const requested = useSyncExternalStore(subscribe, optedIn, () => false);
  const loadingRequested = useSyncExternalStore(subscribe, loadingOptedIn, () => false);
  const reduced = useSyncExternalStore(subscribe, reducedMotion, () => true);
  return { enabled: requested && !reduced, loadingEnabled: loadingRequested, reduced };
}
